import {appContainer} from "../contexts/app";
import Resource from "./resource";
import {fromImmutable, toImmutable, setInState, setListInState, deleteInState} from "./hooks";

export default app => {
  const service = app.service("api/plans");

  const PlanRecord = Resource(
    service,
    {
      name: "",
      price: "",
      description: "",
      features: [],
      allowed_resources: {
        buildings: "",
        facilities: "",
        floors: "",
        infographics: "",
        markerTypeCategories: "",
        markerTypes: "",
        markers: "",
        users: ""
      }
    },
    {}
  );

  appContainer.PlanRecord = PlanRecord;
  app.set("PlanRecord", PlanRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable],
      update: [fromImmutable],
      patch: [fromImmutable],
      remove: []
    },

    after: {
      all: [toImmutable(PlanRecord)],
      find: [setListInState("plans")],
      get: [setInState("plans")],
      create: [setInState("plans")],
      update: [setInState("plans")],
      patch: [setInState("plans")],
      remove: [deleteInState("plans")]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/plans.js